import { create } from 'zustand';

export interface IHeatmapAppConfigStore {
  isSyncedFilter: boolean;

  // Actions
  setIsSyncedFilter: (isSynced: boolean) => void;
}

export const useHeatmapAppConfigStore = create<IHeatmapAppConfigStore>()((set) => ({
  isSyncedFilter: false,

  setIsSyncedFilter: (isSynced) => set({ isSyncedFilter: isSynced }),
}));
